import { ReactNode } from "react";

export type IApplicationAdditionalRoutes = {
  Component: ReactNode,
  key: string;
}
export const ApplicationAdditionalRoutes: IApplicationAdditionalRoutes[] = [];